import React, { useState, useEffect } from "react";
import "./SlideShow.css"; // Je bestaande CSS of een aangepaste versie

const reviews = [
    {
        tekst: `Typisch Grieks restaurant met bijzonder vers en perfect bereide schotels...`,
        auteur: "Rob Kollmann",
    },
    {
        tekst: `Gezellig en goed eten. Vriendelijk personeel...`,
        auteur: "John van den Bungelaar",
    },
    {
        tekst: `Vriendelijke bediening en super lekker eten...`,
        auteur: "Stephan Hoffman",
    },
    {
        tekst: `Vriendelijk en geduldig personeel, alles was heerlijk gaar...`,
        auteur: "Wim Melching",
    },
    {
        tekst: `Restaurant Paros is een gezellig en mooi ingerichte zaak...`,
        auteur: "Karin M",
    },
];

const Slideshow = () => {
    const [slideIndex, setSlideIndex] = useState(0);

    useEffect(() => {
        const timer = setTimeout(() => {
            setSlideIndex((prev) => (prev + 1) % reviews.length);
        }, 5000);
        return () => clearTimeout(timer);
    }, [slideIndex]);

    return (
        <div className="slideshow">
            <div className="slideshow-container">
                {reviews.map((review, index) => (
                    <div
                        key={index}
                        className="mySlides fade"
                        style={{ display: index === slideIndex ? "block" : "none" }}
                    >
                        <h4>wat onze gasten van paros vinden</h4>
                        <p className="slideshow-text">{review.tekst}</p>
                        <p className="slideshow-text">– {review.auteur}</p>
                    </div>
                ))}
            </div>

            <br />
            <div className="t-center">
                {reviews.map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${index === slideIndex ? "active" : ""}`}
                        onClick={() => setSlideIndex(index)}
                    ></span>
                ))}
            </div>
        </div>
    );
};

export default Slideshow;
